var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit"},[_c('div',{staticClass:"edit-content"},[_c('div',{staticClass:"edit-item"},[_c('div',{staticClass:"title"},[_vm._v("标题")]),_c('el-input',{attrs:{"placeholder":"请输入内容"},model:{value:(_vm.editForm.label),callback:function ($$v) {_vm.$set(_vm.editForm, "label", $$v)},expression:"editForm.label"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }